/* Luxury collection strip: small arrow control for optional overflow items. */
(() => {
  function initStrip(section = document) {
    section.querySelectorAll('.luxury-collection-strip').forEach((strip) => {
      if (strip.dataset.collectionStripReady === 'true') return;

      const track = strip.querySelector('[data-luxury-collection-track]');
      const prev = strip.querySelector('[data-luxury-collection-prev]');
      const next = strip.querySelector('[data-luxury-collection-next]');

      if (!track || !prev || !next) return;
      strip.dataset.collectionStripReady = 'true';

      const getStep = () => {
        const item = track.querySelector('.luxury-collection-strip__item');
        return item ? item.getBoundingClientRect().width : track.clientWidth;
      };

      const updateButtons = () => {
        const maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  document.addEventListener('DOMContentLoaded', () => initStrip());
  document.addEventListener('shopify:section:load', (event) => initStrip(event.target));
})();
/* End luxury collection strip. */
